import { Location } from "@/custom-types/Location";

export default (location: Location) =>
  !!location.street?.number &&
  !!location.street?.name &&
  !!location.city &&
  !!location.state &&
  !!location.zip &&
  !!location.coordinates;
